import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppointmentService } from 'src/app/appointment/appointment.service';
import { NewCase } from './new-case';
import { NotifierService } from 'angular-notifier';
import { TranslateOrgSpecificPipe } from '../pipes/translate-org-specific.pipe';
import { UserService } from 'src/app/user/user.service';
import { Constants } from 'src/app/app.constants';
import { analyzeAndValidateNgModules } from '@angular/compiler';

@Component({
  selector: 'app-new-case',
  templateUrl: './new-case.component.html',
  styleUrls: ['./new-case.component.css']
})
export class NewCaseComponent implements OnInit {
  @Input() public data;
  public currentlyClickedCardIndex: number;
  public array: any[] = [];
  public caseList: any[] = [];
  public county = 0;
  heading: string;
  caseCountyList: any[];
  selectedCases: any[] = [];
  newCase = new NewCase();
  newCaseQuestions: any[] = [];
  role: string;
  is_participant = false;
  is_casemanager = false;
  question_array_length: number;
  is_last_que = false;
  is_prev_but = false;
  participantId = 0;
  is_others_choice = false;
  question_answer: any[] = [];
  prev_clicked = false;
  othersReason: any;
  otherCase: any;
  is_answered = false;
  no_questions = false;
  constructor(public activeModal: NgbActiveModal
    , private appointmentService: AppointmentService
    , private notifier: NotifierService,
    private transorgpipe: TranslateOrgSpecificPipe,
    private userService: UserService,
    private elementRef: ElementRef,

  ) { }
  case_question_block;
  signup_form_block;
  client_list_block;
  new_reason_block;
  last_element_call = true;
  count: number;
  question_footer;
  patients: any[] = [];
  selected_patient_id = 0;
  searchText;
  caseId = 0;
  question_count = 0;
  is_other_case = false;
  AppoinmentId = 0;
  clientSelected = false;
  ngOnInit() {

    if (this.data) {
      this.participantId = this.data.participantId;
      this.caseId = this.data.caseId;
      this.AppoinmentId = this.data.AppoinmentId ? this.data.AppoinmentId : 0;
      this.clientSelected = this.data.clientSelected ? this.data.clientSelected : false;


    }
    this.getUserRole();



    this.signup_form_block = this.elementRef.nativeElement.querySelector('.new-reason');
    this.question_footer = this.elementRef.nativeElement.querySelector('.question-footer');
    this.client_list_block = this.elementRef.nativeElement.querySelector('.client-list');
    this.getCaseList();
    this.getCaseCountyList();

  }
  getUserRole() {

    this.userService.getUserInfo().subscribe(
      (info: any) => {

        this.role = info.roles[0];
        if (this.role == this.transorgpipe.transform('Clinician')) {
          this.is_casemanager = true;
          this.heading = this.transorgpipe.transform('NewCase');

          this.loadPatients();
          if (this.participantId > 0) {
            this.signup_form_block.style.display = 'block';
          } else if (this.AppoinmentId > 0 || this.clientSelected) {
            this.signup_form_block.style.display = 'block';
            this.client_list_block.style.display = 'none';
            this.participantId = this.data.EditAppoinmentPatientId ? this.data.EditAppoinmentPatientId : 0;

          } else if (this.caseId > 0) {
            this.heading = this.transorgpipe.transform('EditCase');

            this.newCase.case_id = this.caseId;

            this.appointmentService.GetNewCaseQuestions(this.newCase).subscribe(
              (data: any) => {
                if (data.length > 0) {
                  this.newCaseQuestions = data;
                  this.question_array_length = this.newCaseQuestions.length;
                  let question_array = [];
                  question_array = data;

                  // Below foreach for save allready answered questions to question_answer array
                  // elementanswer== 0 means ,question have multipile answers(checkbox type)
                  // elementanswer= null means ,question not answered(client created cases)
                  question_array.forEach(element => {
                    if (element.answer != null && element.answer != '') {
                      if (element.answer == 0) {
                        let index = 0; // index of checkbox answerlist
                        element.checkboxAnswerChoiceIdList.forEach(obj => {

                          const a = { answer: element.answer, 'answerChoiceId': obj, 'answerText': element.checkboxAnswerTextList[index], 'issueQuestionId': element.issueQuestionId, 'remarks': element.checkboxRemarkList[index], 'isChecked': true };
                          this.question_answer.push(a);
                          index++;
                        });
                        this.is_answered = true;

                      } else {
                        const a = { answer: element.answer, 'answerChoiceId': element.answer, 'answerText': element.answerText, 'issueQuestionId': element.issueQuestionId, 'remarks': element.remarks };
                        this.question_answer.push(a);
                      }

                      this.is_answered = true;

                    }


                  });

                  // below code for question type radio buttons answer binding
                  if (this.newCaseQuestions[0].questiontypeCd == Constants.RadioButtonType) {

                    const qid = this.newCaseQuestions[0].issueQuestionId;

                    let found = this.question_answer.find(ele => ele.issueQuestionId == qid && ele.answerText == Constants.Other);

                    if (!found) {
                      this.is_others_choice = false;
                    }

                    if (!found) {

                      found = this.question_answer.find(ele => ele.issueQuestionId == qid);
                    }
                    const index = this.question_answer.indexOf(found);
                    if (this.question_answer[index].remarks != '' && this.question_answer[index].answerText == Constants.Other) {

                      this.is_others_choice = true;
                      this.othersReason = this.question_answer[index].remarks;
                    } else {
                      this.is_others_choice = false;

                    }



                  } else if (this.newCaseQuestions[0].questiontypeCd == Constants.CheckBoxQuestion) {
                    // Question type CheckBox, answer binding
                    const question_id = this.newCaseQuestions[0].issueQuestionId;
                    const other_found = this.question_answer.find(ele => ele.issueQuestionId == question_id && ele.answerText == Constants.Other);

                    if (other_found) {
                      this.is_others_choice = true;
                    }
                    this.othersReason = other_found.remarks;
                  }


                } else {
                  this.notifier.notify('error', this.transorgpipe.transform('ErrorMessageForEditCase'));
                  this.activeModal.close();
                }
              });
          } else {
            this.signup_form_block.style.display = 'none';
            this.client_list_block.style.display = 'block';

          }


        } else {
          this.heading = this.transorgpipe.transform('NewReason');

          this.signup_form_block.style.display = 'block';

          this.is_participant = true;

        }

      });
  }
  // closePopup
  closeModal(msg: string) {
    this.activeModal.close(msg);
  }

  loadPatients() {
    this.appointmentService.getPatientslookup().subscribe((patients: any) => {
      this.patients = patients;

    });
  }
  getCaseList() {
    this.appointmentService.getissueCategoryList().subscribe(
      (data: any) => {
        this.caseList = data;
      }
    );
  }

  getCaseCountyList() {
    this.appointmentService.getCaseCountyList().subscribe(
      (data: any) => {
        this.caseCountyList = data;
      }
    );
  }

  cardClick(data) {

    // Card select or not(color change)
    const index = this.caseList.indexOf(data);
    this.caseList[index].isHighlight = !this.caseList[index].isHighlight;

    // Return Selected array
    const array_index = this.selectedCases.indexOf(data);
    const found = this.selectedCases.find(ele => ele.issueCategoryId == data.issueCategoryId);
    if (found) {
      this.selectedCases.splice(array_index, 1);
      if (data.issueCategoryName == Constants.Other) {
        this.is_other_case = false;
      }
      this.othersReason = '';

      if (data.questionCount) {
        this.question_count = this.question_count - data.questionCount;
      }
    } else {
      this.selectedCases.push(data);
      if (data.issueCategoryName == Constants.Other) {

        this.is_other_case = true;
      }
      if (data.questionCount) {
        this.question_count = this.question_count + data.questionCount;
      }

    }
    if (this.question_count > 0) {
      this.no_questions = false;
    } else {
      this.no_questions = true;
    }
  }

  onSubmit() {
    const selected: any[] = [];
    this.selectedCases.forEach(element => {
      selected.push(element.issueCategoryId);
    });
    this.newCase.issueCategoryList = selected;
    this.newCase.county_id = this.county;
    this.newCase.client_id = this.participantId;
    this.newCase.otherCaseDetails = this.otherCase;
    if (this.is_casemanager && !this.no_questions) {
      this.GetCaseQuestions();
    } else {
      this.saveNewCase();
    }
  }
  GetCaseQuestions() {

    this.appointmentService.GetNewCaseQuestions(this.newCase).subscribe(
      (data: any) => {
        if (data.status) {
          this.notifier.notify('error', this.transorgpipe.transform('ErrorMessageForcreateNewcase') + '  ' + data.status + ' ' + this.transorgpipe.transform('Casesmall'));
        } else {
          this.newCaseQuestions = data;
          this.question_array_length = this.newCaseQuestions.length;
        }
      });

  }

  callFunction() {
    if (this.last_element_call) {
      this.signup_form_block.style.display = 'none';

      this.case_question_block = document.getElementsByClassName('case-question-div');
      if (this.question_array_length == 1) {
        this.is_last_que = true;
        this.is_prev_but = false;
      }
      (this.case_question_block[0] as HTMLElement).style.display = 'block';
      this.question_footer.style.display = 'block';
      this.count = 0;
    }
    this.last_element_call = false;

  }
  next() {
    let found;
    let index;
    let qid;
    this.is_answered = false;
    this.prev_clicked = false;

    // Save Other remarks
    if (this.is_others_choice) {
      qid = this.newCaseQuestions[this.count].issueQuestionId;
      found = this.question_answer.find(ele => ele.issueQuestionId == qid && ele.answerText == Constants.Other);
      if (!found) {
        found = this.question_answer.find(ele => ele.issueQuestionId == qid);
      }
      index = this.question_answer.indexOf(found);
      this.question_answer[index].remarks = this.othersReason;
      this.is_others_choice = false;
    }
    this.othersReason = '';
    //


    // Next question already answered or not
    qid = this.newCaseQuestions[this.count + 1].issueQuestionId;
    found = this.question_answer.find(ele => ele.issueQuestionId == qid && ele.answerText == Constants.Other);
    if (!found) {
      found = this.question_answer.find(ele => ele.issueQuestionId == qid);
    }
    index = this.question_answer.indexOf(found);

    if (found) {

      this.is_answered = true;

      if (this.question_answer[index].remarks != '' || this.question_answer[index].answerText == Constants.Other) {


        this.is_others_choice = true;
        this.othersReason = this.question_answer[index].remarks;
      } else {
        this.is_others_choice = false;

      }
    }

    (this.case_question_block[this.count] as HTMLElement).style.display = 'none';
    this.is_prev_but = true;

    this.count = this.count + 1;
    if (this.count == this.question_array_length - 1) {
      this.is_last_que = true;
    }
    if (this.count < this.question_array_length) {
      (this.case_question_block[this.count] as HTMLElement).style.display = 'block';
    }


  }

  prev() {
    let found;
    this.is_answered = true;
    const qid = this.newCaseQuestions[this.count - 1].issueQuestionId;
    found = this.question_answer.find(ele => ele.issueQuestionId == qid && ele.answerText == Constants.Other);

    if (!found) {
      this.is_others_choice = false;

      found = this.question_answer.find(ele => ele.issueQuestionId == qid);
    }
    const index = this.question_answer.indexOf(found);
    if (this.question_answer[index].remarks != '' && this.question_answer[index].answerText == Constants.Other) {


      this.is_others_choice = true;
      this.othersReason = this.question_answer[index].remarks;
    } else {
      this.is_others_choice = false;

    }


    this.prev_clicked = true;
    (this.case_question_block[this.count] as HTMLElement).style.display = 'none';
    this.count = this.count - 1;
    if (this.count <= 0) {
      this.is_prev_but = false;

    }
    this.is_last_que = false;

    (this.case_question_block[this.count] as HTMLElement).style.display = 'block';
  }

  saveNewCase() {
    this.appointmentService.saveNewCase(this.newCase).subscribe(
      (data: any) => {
        if (data.status) {

          if (this.role == Constants.Participants) {
            this.notifier.notify('error', this.transorgpipe.transform('ErrorMessageForcreateNewcaseByParticipant') + ' ' + data.status + ' ' + this.transorgpipe.transform('Cases'));
          } else {
            this.notifier.notify('error', this.transorgpipe.transform('ErrorMessageForcreateNewcase') + ' ' + data.status + ' ' + this.transorgpipe.transform('Cases'));
          }

        } else {
          this.notifier.notify('success', this.transorgpipe.transform('Cases') + ' ' + this.transorgpipe.transform('SavedSuccessfully'));
          this.closeModal(data.caseIds);
        }
      }
    );
  }

  onChange(event) {

    if (event.event.answerText == Constants.Other) {
      this.is_others_choice = true;
    }


    const qid = event.event.issueQuestionId;
    const found = this.question_answer.find(ele => ele.issueQuestionId == qid);
    if (event.type == Constants.Radio) {

      if (event.event.answerText != Constants.Other) {
        this.is_others_choice = false;
        this.othersReason = '';

      }
      this.is_answered = true;

      if (found) {
        this.question_answer.splice(this.question_answer.indexOf(found), 1);
        this.question_answer.push(event.event);
      } else {

        this.question_answer.push(event.event);
      }

    } else if (event.type == Constants.Check) {

      if (event.event.isChecked) {
        this.question_answer.push(event.event);
        this.is_answered = true;

      } else {
        const checkbox_datafind = this.question_answer.find(ele => ele.answerChoiceId == event.event.answerChoiceId);


        this.question_answer.splice(this.question_answer.indexOf(checkbox_datafind), 1);
        const answer_found = this.question_answer.find(ele => ele.issueQuestionId == qid);
        if (!answer_found) {

          this.is_answered = false;

        }


      }
      const others_answer_found = this.question_answer.find(ele => ele.issueQuestionId == event.event.issueQuestionId && ele.answerText == Constants.Other);
      if (!others_answer_found) {

        this.is_others_choice = false;
        this.othersReason = '';
      }
    }



  }


  submit() {

    if (this.is_others_choice) {
      const qid = this.newCaseQuestions[this.count].issueQuestionId;
      const found = this.question_answer.find(ele => ele.issueQuestionId == qid);
      const index = this.question_answer.indexOf(found);
      this.question_answer[index].remarks = this.othersReason;
    }
    this.newCase.questionAndAnswer = this.question_answer;
    this.saveNewCase();



  }



  /// client list popup
  ClientCardClick(data) {
    const index = this.patients.indexOf(data);

    // for single selection
    this.patients.forEach(ele => {
      ele.isHighlight = true;
    });
    // Card select or not(color change)
    this.patients[index].isHighlight = !this.patients[index].isHighlight;
    this.participantId = data.patientId;


  }
  clientSelect() {


    this.signup_form_block.style.display = 'block';
    this.client_list_block.style.display = 'none';


  }

}
